import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import DropdownMenu from '@ecp/common/src/components/dropdown/bo/DropdownMenu';
import Button from '@ecp/common/src/components/button/bo/Button';
import { ReactComponent as ExcelIcon } from '@ecp/common/src/assets/icon/icon__excel.svg';

const ExcelWork = ({
  isIconType,
  isSimple,
  hasData,
  handleExcelTemplateDownload: handleExcelTemplateDownloadProp,
  handleExcelDownload: handleExcelDownloadProp,
  handleExcelUpload: handleExcelUploadProp,
}) => {
  const excelWorkItems = useMemo(() => {
    if (isSimple) {
      return [
        { key: 'upload', label: '엑셀업로드' },
        { key: 'download', label: '엑셀다운로드', disabled: !hasData },
      ];
    }
    return [
      { key: 'template', label: '양식다운로드' },
      { key: 'upload', label: '엑셀업로드' },
      { key: 'download', label: '엑셀다운로드', disabled: !hasData },
    ];
  }, [hasData, isSimple]);

  const handleClick = ({ key }) => {
    if (key === 'template') {
      handleExcelTemplateDownloadProp?.();
    } else if (key === 'download') {
      handleExcelDownloadProp?.();
    } else {
      handleExcelUploadProp?.();
    }
  };
  return (
    <DropdownMenu
      isIconType={isIconType}
      items={excelWorkItems}
      menuIcon={ExcelIcon}
      menuLabel={'엑셀작업'}
      onClick={handleClick}
    />
  );
};

ExcelWork.propTypes = {
  hasData: PropTypes.bool,
  handleExcelTemplateDownload: PropTypes.func,
  handleExcelDownload: PropTypes.func,
  handleExcelUpload: PropTypes.func,
  isIconType: PropTypes.bool,
  isSimple: PropTypes.bool,
};

export const ExcelDownload = ({ isSmallType, hasData, onExcelDownload }) => (
  <Button type="Third" width={isSmallType ? '30px' : '112px'} disabled={!hasData} onClick={onExcelDownload}>
    {isSmallType ? (
      <ExcelIcon width={'14px'} height={'15px'} />
    ) : (
      <FlexBox gap={'4px'}>
        <ExcelIcon width={'14px'} height={'15px'} />
        엑셀다운로드
      </FlexBox>
    )}
  </Button>
);

ExcelDownload.propTypes = {
  hasData: PropTypes.bool,
  isSmallType: PropTypes.bool,
  onExcelDownload: PropTypes.func,
};

export default ExcelWork;

export const CustomExcelWork = ({
  hasData,
  customExcelForm,
  handleExcelTemplateDownload: handleExcelTemplateDownloadProp,
  handleExcelDownload: handleExcelDownloadProp,
  handleExcelUpload: handleExcelUploadProp,
}) => {
  const excelWorkItems = useMemo(() => {
    return customExcelForm.map((data) => {
      return data.disabled ? { ...data, disabled: !hasData } : data;
    });
  }, [hasData, customExcelForm]);

  const handleClick = ({ key }) => {
    if (key === 'template') {
      handleExcelTemplateDownloadProp?.();
    } else if (key === 'download') {
      handleExcelDownloadProp?.();
    } else {
      handleExcelUploadProp?.();
    }
  };
  return <DropdownMenu items={excelWorkItems} menuIcon={ExcelIcon} menuLabel={'엑셀작업'} onClick={handleClick} />;
};

CustomExcelWork.propTypes = {
  hasData: PropTypes.bool,
  handleExcelTemplateDownload: PropTypes.func,
  handleExcelDownload: PropTypes.func,
  handleExcelUpload: PropTypes.func,
  isIconType: PropTypes.bool,
  isSimple: PropTypes.bool,
  customExcelForm: PropTypes.array,
};
